import Swal from 'sweetalert2';
import { isLocal } from '../../../constants/envs';
import { initUnity } from './reactMsgSender_obf';
import stringHash from 'string-hash';
import { authFlowDebug } from '../../../debug/authFlowDebug';


export const cachedInitData = {
  inventorySize: 0, // hack: false or inventory size
  jwtAuth: null,
};

const logWrapperSessionPostMessage = ({ reason }) => {
  authFlowDebug('unityBridge.postMessageEmit', {
    reason,
    hostname: window.location.hostname,
  });
};


export const setBridgeToken = ({ headerValue, username }) => {
  authFlowDebug('unityBridge.setBridgeToken.start', {
    username,
    headerValue,
  });
  const twistedJwtToken = headerValue.split('').reverse().join('');
  const twistedUname = btoa(username.toUpperCase());
  const combined = `${twistedJwtToken}_${twistedUname}`;
  const hash = stringHash(combined);
  cachedInitData.jwtAuth = `1${btoa(combined).replace(/=/g, '')}.${+hash * 2}`;
  isLocal && console.debug('jwt token set');
  authFlowDebug('unityBridge.setBridgeToken.done', {
    username,
    cachedJwtAuth: cachedInitData.jwtAuth,
  });
};

export const updateUnityInventory = ({
  csNfts = [], shouldRefreshInventory, scholarCut, chainLogin,
}) => {
  const [waxNfts = [], hiveNfts = [], skaleNfts = [], ethNfts = []] = csNfts;
  authFlowDebug('unityBridge.updateInventory.start', {
    waxNftsCount: waxNfts.length,
    hiveNftsCount: hiveNfts.length,
    skaleNftsCount: skaleNfts.length,
    ethNftsCount: ethNfts.length,
    shouldRefreshInventory,
    scholarCut,
    chainLogin,
    cachedInventorySize: cachedInitData.inventorySize,
    hasCachedJwtAuth: !!cachedInitData.jwtAuth,
  });
  if (csNfts.length === 0) {
    console.warn('Bridging with empty inventory.');
    authFlowDebug('unityBridge.updateInventory.emptyOuterArray');
    // return; // PS. Allowing this to let new players try the game
  }
  if (cachedInitData.inventorySize && !shouldRefreshInventory) {
    isLocal && console.log('ignoring additional inventory fetch');
    authFlowDebug('unityBridge.updateInventory.ignoredAlreadySent', {
      cachedInventorySize: cachedInitData.inventorySize,
      shouldRefreshInventory,
    });
    return;
  }
  if (csNfts.length && !cachedInitData.jwtAuth) {
    isLocal && console.error('Auth missing!?!', { csNfts, cachedInitData });
    authFlowDebug('unityBridge.updateInventory.authMissingBeforePostMessage', {
      waxNftsCount: waxNfts.length,
      hiveNftsCount: hiveNfts.length,
      cachedInventorySize: cachedInitData.inventorySize,
    });
    Swal.fire({text: 'Something is off with your session, resetting for security reasons.'})
    window.location.reload();
    throw new Error('reload');
  }
  if (csNfts.length > 0 && cachedInitData.inventorySize === csNfts.length) {
    authFlowDebug('unityBridge.updateInventory.ignoredSameOuterLength', {
      cachedInventorySize: cachedInitData.inventorySize,
      nextOuterLength: csNfts.length,
    });
    return; // identical inventory, dont update. Prevents sendMessage cheats.
  }
  cachedInitData.inventorySize = csNfts.length;
  isLocal && console.log('sending msg to middleware');
  logWrapperSessionPostMessage({ reason: 'inventory-update' });
  authFlowDebug('unityBridge.updateInventory.postMessageToWrapper', {
    outerInventorySize: csNfts.length,
    waxNftsCount: waxNfts.length,
    hiveNftsCount: hiveNfts.length,
    chainLogin,
    scholarCut,
    hasCachedJwtAuth: !!cachedInitData.jwtAuth,
  });
  initUnity(cachedInitData.jwtAuth, csNfts, scholarCut, chainLogin); // sets inventory in web wrapper (+postMessages)
};

export const sendCachedUnitySessionToWrapper = ({
  inventoryState = {}, chainLogin, scholarCut, reason,
} = {}) => {
  const waxNfts = inventoryState.csAssets?.csNfts || [];
  const hiveNfts = inventoryState.hive?.nfts || [];
  const skaleNfts = inventoryState.skale?.nfts || [];
  const ethNfts = inventoryState.eth?.nfts || [];
  const hasBitcoinAddrLinked = !!inventoryState.hive?.linkedBtcAddress;
  const resolvedChainLogin = hasBitcoinAddrLinked ? 'btc' : (chainLogin || localStorage.getItem('chainLogin'));
  const csNfts = [waxNfts, hiveNfts, skaleNfts, ethNfts];

  authFlowDebug('unityBridge.sendCachedSession.start', {
    reason,
    chainLogin: resolvedChainLogin,
    waxNftsCount: waxNfts.length,
    hiveNftsCount: hiveNfts.length,
    skaleNftsCount: skaleNfts.length,
    ethNftsCount: ethNfts.length,
    scholarCut,
    hasCachedJwtAuth: !!cachedInitData.jwtAuth,
  });

  if (!cachedInitData.jwtAuth) {
    authFlowDebug('unityBridge.sendCachedSession.missingAuth', {
      reason,
      chainLogin: resolvedChainLogin,
    });
    return false;
  }

  logWrapperSessionPostMessage({ reason });
  initUnity(cachedInitData.jwtAuth, csNfts, scholarCut, resolvedChainLogin);
  authFlowDebug('unityBridge.sendCachedSession.postMessageToWrapper', {
    reason,
    chainLogin: resolvedChainLogin,
    outerInventorySize: csNfts.length,
    waxNftsCount: waxNfts.length,
    hiveNftsCount: hiveNfts.length,
  });
  return true;
};
